module.exports = __webpack_public_path__ + "static/media/IMG_9067.f4627443.JPG";